import React from 'react'
import { styled } from '@mui/material'

export const ContentWrapper = styled(({ alignItems, alignSelf, children, flexDirection, justifyContent, ...props }) => (
  <div {...props}>{children}</div>
))`
  align-items: ${props => props.alignItems};
  align-self: ${props => props.alignSelf};
  display: ${props => props.display || 'flex'};
  flex-direction: ${props => props.flexDirection};
  justify-content: ${props => props.justifyContent};
  margin-left: ${props => props.maringleft};
  padding: ${props => props.padding};
  width: ${props => props.width};
`

export const DocumentBox = styled('div')`
  background-color: ${props => props.theme.palette.blue[95]};
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  margin: 0 0 8px 0;
  padding: 14px 0;
  width: 100%;
`

export const DocumentFile = styled(({ alignItems, children, flexFlow, ...rest }) => <a {...rest}>{children}</a>)`
  align-items: ${props => props.alignItems};
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  display: ${props => props.display || 'block'};
  flex-flow: ${props => props.flexFlow};
  font-size: 12px;
  text-decoration: underline;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`

export const DocumentFileLoading = styled(DocumentFile)`
  color: ${props => props.theme.palette.gray[20]};
  cursor: initial;
  text-decoration: initial;

  &:hover {
    color: ${props => props.theme.palette.gray[20]};
  }
`

export const Subtitle = styled('p')`
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 9px;
`

export const Title = styled('p')`
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  margin-bottom: 8px;
`
